export enum DiscountTypeEnum {
    Price = 1,
    Percent = 2
}